import { render, staticRenderFns } from "./tinkSlide.vue?vue&type=template&id=53b85e93"
import script from "./tinkSlide.vue?vue&type=script&lang=js"
export * from "./tinkSlide.vue?vue&type=script&lang=js"
import style0 from "./tinkSlide.vue?vue&type=style&index=0&id=53b85e93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports